document.addEventListener('DOMContentLoaded', () => {
   const searchIcon = document.querySelector('div#search-icon-open');
   const searchInput = document.querySelector('input#Search-In-Modal-1');

   if (searchIcon && searchInput) {
      searchIcon.addEventListener('click', () => {
         setTimeout(() => {
            searchInput.click();
            searchInput.focus();
            handleSwiper();
         }, 600);

          setTimeout(() => {
            handleSwiper();
         }, 900);
      });
   }
})
window.onWizzyScriptLoaded = function () {

   if (window.innerWidth < 768) {
      let newDiv = document.getElementById("wizzy-search-wrapper-mobile-new").text;
      let oldDiv = document.getElementById("wizzy-search-wrapper");
      oldDiv.text = newDiv;

      newDiv = document.getElementById("wizzy-search-summary-new").text;
      oldDiv = document.getElementById("wizzy-search-summary");
      oldDiv.text = newDiv;
   } else {
      let newDiv = document.getElementById("wizzy-search-wrapper-new").text;
      let oldDiv = document.getElementById("wizzy-search-wrapper");
      oldDiv.text = newDiv;
   }

   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, function (data) {

      data.filters.configs.layout = 'v1';
      data.filters.configs.keepOpenedInMobileAfterApply=true;
      window.wizzyConfig.search.configs.pagination.appendInExistingList = true;
      return data;
   })
   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT, function (data) {

      data.filters.configs.layout = 'v1';
      data.filters.configs.keepOpenedInMobileAfterApply=true;
      window.wizzyConfig.search.configs.pagination.appendInExistingList = true;
      return data;
   })

   function initTopQuickFilters() {
      const wrapper = document.querySelector('.search-filters-top-wrapper');
      const facetBlock = document.querySelector(
         '.wizzy-filters-facet-block[data-key="product_product_type"]'
      );

      if (!wrapper || !facetBlock) return;

      const listItems = facetBlock.querySelectorAll(
         '.wizzy-facet-body .wizzy-facet-list .wizzy-facet-list-item'
      );

      if (!listItems || listItems.length <= 1) {
         wrapper.classList.remove('has-quick-filters');
         const existing = wrapper.querySelector('.top-quick-filters');
         if (existing) existing.remove();
         return;
      }

      wrapper.classList.add('has-quick-filters');
      let results_list = document.querySelector('.wizzy-search-results');
      if(results_list)
      {
         results_list.classList.add('results-with-quick-filter');
      }

      const existing = wrapper.querySelector('.top-quick-filters');
      if (existing) existing.remove();

      const container = document.createElement('div');
      container.className = 'top-quick-filters';

      const prevBtn = document.createElement('div');
      prevBtn.className = 'custom-scroll-btn previous';
      prevBtn.innerHTML = `
         <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none">
            <path d="M6 12H18M6 12L11 7M6 12L11 17"
            stroke="#000000"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"/>
         </svg>
      `;

      const nextBtn = document.createElement('div');
      nextBtn.className = 'custom-scroll-btn next';
      nextBtn.innerHTML = `
         <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none">
            <path d="M6 12H18M18 12L13 7M18 12L13 17"
            stroke="#000000"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"/>
         </svg>
      `;

      const ul = document.createElement('ul');
      ul.className = 'quick-filter-list';

      const allLi = document.createElement('li');
      allLi.className = 'quick-filter-item';
      allLi.textContent = 'All Products';

      allLi.addEventListener('click', () => {
         listItems.forEach(item => {
            const input = item.querySelector('input');
            if (input && input.checked) {
            input.click();
            }
         });
      });

      ul.appendChild(allLi);

      listItems.forEach(item => {
         const term = item.getAttribute('data-term');
         if (!term) return;

         const li = document.createElement('li');
         li.className = 'quick-filter-item';
         li.textContent = term;

         const input = item.querySelector('input');

         if (input && input.checked) {
            li.classList.add('active');
         }

         li.addEventListener('click', () => {
            if (input) {
            input.click();
            }
         });

         ul.appendChild(li);
      });

      const anyChecked = facetBlock.querySelector('input:checked');
      if (!anyChecked) {
         allLi.classList.add('active');
      }

      prevBtn.addEventListener('click', () => {
         ul.scrollBy({ left: -200, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
         ul.scrollBy({ left: 200, behavior: 'smooth' });
      });

      container.appendChild(prevBtn);
      container.appendChild(ul);
      container.appendChild(nextBtn);

      wrapper.prepend(container);
   }

   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.VIEW_RENDERED, function (data) {
      // console.log("view_render", data);
      if(window.wizzyConfig.common.isOnCategoryPage)
      {
         document.body.classList.remove('wizzy-search');
         document.body.classList.add('wizzy-collection');
         let collection_title = document.querySelector('.wz-collection-title');
         if(collection_title)
         {
            let title = window.wizzyConfig.common.categoryName;
            collection_title.textContent = title;
         }
         let products_count = data.data?.response?.payload?.total;
         if(products_count)
         {
            let count_ele = document.querySelector('.wizzy-total-products .wizzy-search-summary-wrapper .wizzy-search-summary-container');
            if(count_ele)
            {
               count_ele.textContent = products_count;
            }
         }
         initTopQuickFilters();
      }
      else
      {
         document.body.classList.add('wizzy-search');
         document.body.classList.remove('wizzy-collection');
      }
      const el = document.querySelector('.wizzy-collection .search-filters-top-wrapper');

      window.addEventListener('scroll', () => {
         if(el)
         {
            if (window.scrollY === 0) {
               el.style.top = ''; // remove top when at top
               el.style.border = '';
            } else {
               el.style.top = '77px'; // apply when scrolled
               el.style.border = '1px solid rgb(225, 225, 225)';
            }
         }
      });
      
      handleGridView();
      handleSwiper();
      document.querySelectorAll(
      'modal-dialog#PopupModal-variant_picker, modal-dialog#PopupModal-buy_buttons, product-modal#ProductModal-template--26358259024235__main'
      ).forEach(el => {
      el.style.display = 'none';
      });

      return data;
   }, 1);

   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED, function (data) {
      handleGridView();
      handleSwiper();
      if(window.wizzyConfig.common.isOnCategoryPage)
      {
         document.body.classList.remove('wizzy-search');
         document.body.classList.add('wizzy-collection');
         let collection_title = document.querySelector('.wz-collection-title');
         if(collection_title)
         {
            let title = window.wizzyConfig.common.categoryName;
            collection_title.textContent = title;
         }
         let products_count = data.data?.response?.payload?.total;
         if(products_count)
         {
            let count_ele = document.querySelector('.wizzy-total-products .wizzy-search-summary-wrapper .wizzy-search-summary-container');
            if(count_ele)
            {
               count_ele.textContent = products_count;
            }
         }
         initTopQuickFilters();
      }
      else
      {
         document.body.classList.add('wizzy-search');
         document.body.classList.remove('wizzy-collection');
      }
      const el = document.querySelector('.wizzy-collection .search-filters-top-wrapper');

      window.addEventListener('scroll', () => {
         if(el)
         {
            if (window.scrollY === 0) {
            el.style.top = ''; // remove top when at top
            el.style.border = '';
            } else {
               el.style.top = '77px'; // apply when scrolled
               el.style.border = '1px solid rgb(225, 225, 225)';
            }
         }
      });
      return data;
   }, 1);

   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, function (data) {
      data.forEach(product => {
         product.sellingPrice = product.sellingPrice?.replace(/\.00$/, '');
         product.price = product.price?.replace(/\.00$/, '');
         let attributes = product.attributes;
         if(attributes)
         {
            attributes.forEach((attr) => {
               if(attr.id === "product_tags"){
                  let tagValues = attr.values[0].value[0];
                  if(tagValues.includes('New Flag')){
                     product.newTag = true;
                  }
               }
            });
         }
         product.images = product.images.slice(1);
      });

      return data;
   }, 1);

   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function (data) {
      document.querySelector('button#search-modal-close')?.click();


      return data;
   }, 1);


   function handleGridView() {
      const gridContainer = document.querySelector('.wizzy-search-grid');
      const smallBtn = document.querySelector('button.per-row__button.small');
      const largeBtn = document.querySelector('button.per-row__button.large');

      if (!gridContainer) return;

      if (smallBtn) {
         smallBtn.addEventListener('click', () => {
            gridContainer.setAttribute('data-productis-in-row', 'small');
            smallBtn.classList.add('active');
            largeBtn.classList.remove('active');
            sessionStorage.setItem('wizzyGridSize', 'small');

         });
      }

      if (largeBtn) {
         largeBtn.addEventListener('click', () => {
            gridContainer.setAttribute('data-productis-in-row', 'large');
            largeBtn.classList.add('active');
            smallBtn.classList.remove('active');
            sessionStorage.setItem('wizzyGridSize', 'large');
         });
      }

      const savedValue = sessionStorage.getItem('wizzyGridSize') || 'small';

      gridContainer.setAttribute('data-productis-in-row', savedValue);

      if (savedValue === 'large') {
         largeBtn?.classList.add('active');
         smallBtn?.classList.remove('active');
      } else {
         smallBtn?.classList.add('active');
         largeBtn?.classList.remove('active');
      }
   }

   // function handleSwiper(){
   //    const toolbarInterval = setInterval(() => {
   //       if ($(".card__inner").length > 0) {
   //          const swiperElements = document.querySelectorAll(".swiper.product-card-js");

   //          swiperElements.forEach((toolbar_nav_1) => {
   //             var toolbar_nav_col = new Swiper(toolbar_nav_1, {
   //                slidesPerView: "auto",
   //                navigation: {
   //                   nextEl: ".swiper-button-next",
   //                   prevEl: ".swiper-button-prev",
   //                   clickable: !0,
   //                   loop: !1,

   //                }

   //             });

   //             const swiper = new Swiper(toolbar_nav_1, {
   //                loop: !1,
   //                pagination: {
   //                   el: ".swiper-pagination",
   //                   clickable: !0,
   //                   type: "bullets"
   //                },
   //             })
   //          })
   //          clearInterval(toolbarInterval)
   //       }


   //    }, 500)
   // }


}

function handleSwiper() {
  const toolbarInterval = setInterval(() => {
    if (document.querySelectorAll(".card__inner").length > 0) {

      const swiperElements = document.querySelectorAll(".swiper.product-card-js");

      swiperElements.forEach((swiperEl) => {

        // Prevent re-init
        if (swiperEl.swiper) return;

        new Swiper(swiperEl, {
          slidesPerView: "auto",
          loop: false,

          navigation: {
            nextEl: swiperEl.querySelector(".swiper-button-next"),
            prevEl: swiperEl.querySelector(".swiper-button-prev"),
          },

          pagination: {
            el: swiperEl.querySelector(".swiper-pagination"),
            clickable: true,
            type: "bullets",
          }
        });
      });

      clearInterval(toolbarInterval);
    }
  }, 500);
}